import React from 'react'
import PropTypes from 'prop-types'
import Step from '../../../components/Step'
import Select from 'react-select'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'
import * as validation from 'lib/validation'
import './SiteTools.scss'

const PRESCRIBER = 'Prescriber'
const PRESCRIBER_ADDRESS = 'PrescriberAddress'
const PRESCRIBER_PHONE_NUMBER = 'PrescriberPhoneNumber'
const PRESCRIBER_NPI = 'PrescriberNPI'
const PRESCRIBER_SIGNATURE = 'PrescriberSignature'
const PRESCRIBER_EMAIL = 'PrescriberEmail'

export default class EditPrescriberView extends React.Component {
  static propTypes = {
    prescriber: PROPTYPES.prescriber,
    updatePrescriber: PropTypes.func,
    isUpdatingPrescriber: PropTypes.bool,
    isUploadingSignature: PropTypes.bool,
  }

  static defaultProps = {
    prescriber: {},
    updatePrescriber: _.noop,
    isUpdatingPrescriber: false,
    isUploadingSignature: false,
  }

  constructor (props) {
    super(props)
    let { prescriber } = props
    this.state = {
      [`input${PRESCRIBER}`]: prescriber.name || '',
      [`input${PRESCRIBER_EMAIL}`]: prescriber.email || '',
      [`input${PRESCRIBER_ADDRESS}`]: prescriber.address || '',
      [`input${PRESCRIBER_PHONE_NUMBER}`]: prescriber.phone_number || '',
      [`input${PRESCRIBER_NPI}`]: prescriber.npi || '',
      [`input${PRESCRIBER_SIGNATURE}`]: '',
    }
  }

  handleInput = (resourceType, input) => {
    this.setState({ [`input${resourceType}`]: input })
    return input
  }

  renderPrescriberSignatureInput = (optional = false) => {
    const { inputPrescriberSignature } = this.state
    return (
      <div>
        <div>Signature {optional ? '(Optional)' : ''}</div>
        <input
          type='file'
          onChange={(event) => this.handleInput(PRESCRIBER_SIGNATURE, event.target.files[0])}
        />
        {
          inputPrescriberSignature
          ? <img className='signature' src={URL.createObjectURL(inputPrescriberSignature)} />
          : null
        }
      </div>
    )
  }

  renderAlert = (resourceType) => {
    const alert = this.state[`alert${resourceType}`]
    if (alert && alert.show) {
      return _.map(alert.errors, (error, index) => (
        <div className='alert alert-danger' key={index}>{error}</div>
      ))
    }
  }

  // check to see if requirements are met before enabling user to take action, true if prereqs met
  checkPrereqs = (resourceType) => {
    const {
      inputPrescriber,
      inputPrescriberAddress,
      inputPrescriberPhoneNumber,
      inputPrescriberNPI,
    } = this.state
    if (resourceType === PRESCRIBER) {
      if (inputPrescriber && inputPrescriberAddress && inputPrescriberPhoneNumber &&
        inputPrescriberNPI) {
        return true
      }
    }
    return false
  }

  handleUpdatePrescriber = () => {
    const { prescriber } = this.props
    const {
      inputPrescriber,
      inputPrescriberEmail,
      inputPrescriberPhoneNumber,
      inputPrescriberAddress,
      inputPrescriberNPI,
      inputPrescriberSignature
    } = this.state
    const { updatePrescriber } = this.props
    const prescriberResult = validation.validatePrescriberName(inputPrescriber)
    const emailResult = validation.validateEmail(inputPrescriberEmail, false)
    const phoneResult = validation.validatePhoneNumber(inputPrescriberPhoneNumber)
    const npiResult = validation.validateNPI(inputPrescriberNPI)

    this.setState({
      [`alert${PRESCRIBER}`]: {
        show: !prescriberResult.valid,
        errors: prescriberResult.errors
      },
      [`alert${PRESCRIBER_EMAIL}`]: {
        show: !emailResult.valid,
        errors: emailResult.errors
      },
      [`alert${PRESCRIBER_PHONE_NUMBER}`]: {
        show: !phoneResult.valid,
        errors: phoneResult.errors
      },
      [`alert${PRESCRIBER_NPI}`]: {
        show: !npiResult.valid,
        errors: npiResult.errors
      }
    })

    if (prescriberResult.valid && emailResult.valid && phoneResult.valid && npiResult.valid) {
      updatePrescriber(
        prescriber.id,
        {
          first_name: inputPrescriber.split(' ')[0],
          last_name: inputPrescriber.split(' ')[1],
          email: inputPrescriberEmail,
          address: inputPrescriberAddress,
          phone_number: inputPrescriberPhoneNumber,
          npi: inputPrescriberNPI,
          inputPrescriberSignature,
        },
        inputPrescriberSignature
      )
    }
  }

  render () {
    const {
      inputPrescriber,
      inputPrescriberEmail,
      inputPrescriberAddress,
      inputPrescriberPhoneNumber,
      inputPrescriberNPI,
    } = this.state

    const {
      prescriber,
      isUploadingSignature,
      isUpdatingPrescriber,
    } = this.props

    return (
      <div>
        <Step
          title='Prescriber'
        >
          {
            <div>
              <div>Name</div>
              { this.renderAlert(PRESCRIBER) }
              <input
                type='text'
                className='input'
                value={inputPrescriber}
                onChange={(event) => this.handleInput(PRESCRIBER, event.target.value)}
              />
              <div>Email</div>
              { this.renderAlert(PRESCRIBER_EMAIL) }
              <input
                type='email'
                className='input'
                value={inputPrescriberEmail}
                onChange={(event) => this.handleInput(PRESCRIBER_EMAIL, event.target.value)}
              />
              <div>Address</div>
              <input
                type='text'
                className='input'
                value={inputPrescriberAddress}
                onChange={(event) => this.handleInput(PRESCRIBER_ADDRESS, event.target.value)}
              />
              <div>Phone Number</div>
              { this.renderAlert(PRESCRIBER_PHONE_NUMBER) }
              <input
                type='text'
                className='input'
                value={inputPrescriberPhoneNumber}
                onChange={(event) => this.handleInput(PRESCRIBER_PHONE_NUMBER, event.target.value)}
              />
              <div>NPI</div>
              { this.renderAlert(PRESCRIBER_NPI) }
              <input
                type='text'
                className='input'
                value={inputPrescriberNPI}
                onChange={(event) => this.handleInput(PRESCRIBER_NPI, event.target.value)}
              />
              {
                this.renderPrescriberSignatureInput(false)
              }
              <img src={prescriber.public_signature_url} className='signature' />
              <div className='button-container'>
                <button
                  className='btn btn-primary action-button'
                  onClick={() => this.handleUpdatePrescriber()}
                  disabled={!this.checkPrereqs(PRESCRIBER) && isUploadingSignature && isUpdatingPrescriber}
                >
                  Update Prescriber
                </button>
              </div>
            </div>
          }
        </Step>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/EditPrescriberView.jsx